/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Storage_TitleInputs */

const es_settings_storage_title = /** @type {(inputs: Settings_Storage_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Almacenamiento`)
};

const en_settings_storage_title = /** @type {(inputs: Settings_Storage_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Storage`)
};

/**
* | output |
* | --- |
* | "Storage" |
*
* @param {Settings_Storage_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const settings_storage_title = /** @type {((inputs?: Settings_Storage_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Storage_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_storage_title(inputs)
	return en_settings_storage_title(inputs)
});
export { settings_storage_title as "settings.storage.title" }